/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.organizationModule')
.service('BulbOrganizationService', BulbOrganizationService);

/**
 * Handles various things on the Organization Dashboard, such as breadcrumbs and cached data.
 *
 */
function BulbOrganizationService() {

  var that = this;
  this.breadcrumbStack = [];

  this.addToBreadcrumb = function(addedOrg) {
    var index = that.breadcrumbStack.map(function(e) { return e.id; }).indexOf(addedOrg.id);
    if (index === -1) {
      that.breadcrumbStack.push(addedOrg);
    } else {
      that.goToBreadcrumb(addedOrg, index);
    }
  };

  this.goToBreadcrumb = function(designatedOrg, index) {
    that.breadcrumbStack.length = (index + 1);
  };

  this.getBreadcrumbStack = function() {
    return that.breadcrumbStack;
  };

  this.deleteBreadcrumbStack = function() {
    that.breadcrumbStack = [];
  };
}

